import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { loadPerformance } from '../../actions/data'
import { getAggs, getConstituents, getTickerListing } from '../../reducers/data'
import DetailsTable from './DetailsTable/DetailsTable'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import CompText from './Compliance/CompText'
import './App.css'

library.add(faQuestionCircle, faCircleNotch)
class App extends PureComponent {
  componentDidMount() {
    this.props.loadPerformance()
  }

  render() {
    const { earningsTickerListing, initialLoad } = this.props
    if (initialLoad === false) {
      return (
        <div className='earnings-app' style={{ textAlign: 'center' }}>
          <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#050139', marginTop: '45px' }} spin />
        </div>
      )
    } else if (earningsTickerListing.length > 0) {
      return (
        <div className='earnings-app'>
          <DetailsTable />
          <CompText />
        </div>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    earningsConstituents: getConstituents,
    earningsAggs: getAggs,
    earningsTickerListing: getTickerListing,
    initialLoad: state.data.initialLoad
  }
}

export default connect(mapStateToProps, {
  loadPerformance
})(App)



// WEBPACK FOOTER //
// ./src/components/App/App.js